import {
  AutomatedTestAnomalyConfig,
  AutomatedTestConfigurationApi,
} from '@elementary/common-ui/types';
import { VolumeDetectionMode } from 'shared/types';

export const getInitialVolumeMode = (
  config: AutomatedTestConfigurationApi,
): VolumeDetectionMode => {
  if (config.type !== 'anomaly_detection') return 'anomaly_detection';
  const { spike_threshold, drop_threshold } = config.anomaly_config;
  return spike_threshold != null || drop_threshold != null
    ? 'percentage_thresholds'
    : 'anomaly_detection';
};

export const applyThresholdMode = (
  config: AutomatedTestAnomalyConfig,
  mode: VolumeDetectionMode,
): AutomatedTestAnomalyConfig => {
  if (mode === 'anomaly_detection') {
    return { ...config, spike_threshold: null, drop_threshold: null };
  }
  return {
    ...config,
    spike_threshold:
      config.anomaly_direction === 'DROP' ? null : config.spike_threshold,
    drop_threshold:
      config.anomaly_direction === 'SPIKE' ? null : config.drop_threshold,
  };
};
